import { render, staticRenderFns } from "./accountDeletion.vue?vue&type=template&id=d475377e&scoped=true"
import script from "./accountDeletion.vue?vue&type=script&lang=js"
export * from "./accountDeletion.vue?vue&type=script&lang=js"
import style0 from "./accountDeletion.vue?vue&type=style&index=0&id=d475377e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d475377e",
  null
  
)

export default component.exports